import { render, staticRenderFns } from "./VuesticSidebar.vue?vue&type=template&id=cd0daec0"
import script from "./VuesticSidebar.vue?vue&type=script&lang=js"
export * from "./VuesticSidebar.vue?vue&type=script&lang=js"
import style0 from "./VuesticSidebar.vue?vue&type=style&index=0&id=cd0daec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports